// extracted by mini-css-extract-plugin
module.exports = {"label":"FormLabel-module__label","note":"FormLabel-module__note"};